import { useContext,useState } from 'react';

import ArtworkDataContext from '@/context/ArtworkDataContext';
import useProtectAction from '@/hooks/useProtectAction';
import useStateHandler from '@/hooks/useStateHandler';
import useTranslations from '@/i18n/useTranslations';
import UserService from '@/services/user.service';
import ContinueButton from '@/shared-components/buttons/components/ContinueButton';
import ArtworkImage from '@/shared-components/cards/components/ArtworkImage';
import Text from '@/shared-components/text/components/Text';

import RateCategory from './components/RateCategory';

import './index.css';

export default function RateArtworkForm({ onRateArtwork }) {
  const t = useTranslations('common.shared.artwork_view.socials.ratings.form');
  const { cacheHandler, stateHandler } = useStateHandler();
  const { artworkData } = useContext(ArtworkDataContext);
  const [loading, setLoading] = useState(false);
  const privateActionHandler = useProtectAction({ typeOfProtection: "USER_ACCOUNT_REQUIRED" });
  async function submitArtworkRating(e) {
    e.preventDefault();
    setLoading(true);

    const myRating = {
      emotions: e.target.emotions.value,
      style: e.target.style.value,
      time_travel: e.target.time_travel.value
    };

    try {
      const { response, data } = await UserService.submitRating(artworkData._id, myRating);

      if(response.ok) {
        cacheHandler.triggerAction("NEW_RATING");
        onRateArtwork(data);
      }
    } catch (_error) {
      // Keep the form available for a retry when the request cannot be completed.
    } finally {
      setLoading(false);
    }
  }

  return (
    <>
      <form 
        onSubmit={(e)=>{
          e.preventDefault();
          stateHandler.set("unregisteredUser", "guest_rating");
          privateActionHandler(()=>submitArtworkRating(e));
        }} 
        className={`artwork-view-rate-artwork-form__container ${loading ? "read-only" : ""}`}
      >
        <ArtworkImage 
          image={artworkData.artwork_media.artwork_main_picture.image_id} 
          imageTemplateClassName="artwork-view-rate-artwork-form__artwork-image" 
          imageClassName="artwork-view-rate-artwork-form__artwork-image"
        />

        <Text
          className="artwork-view-rate-artwork-form__see-results"
          paragraph>
          {t('headline')}
        </Text>

        <RateCategory 
          category="Emotion" 
          text={t('categories.emotions.description')} 
          element="emotions"
        />

        <RateCategory 
          category="Style" 
          text={t('categories.style.description')} 
          element="style"
        />

        <RateCategory 
          category="Time travel" 
          text={t('categories.time_travel.description')}
          element="time_travel"
        />

        <ContinueButton className="rate-artwork__submit-button" loading={loading}>
          {t('submit')}
        </ContinueButton>
      </form>
    </>
  );
}
